(function () {
  function initCarousels() {
    document.querySelectorAll('.card-carousel').forEach(function (carousel) {
      if (carousel.dataset.carouselInitialised) return;
      carousel.dataset.carouselInitialised = 'true';

      var track = carousel.querySelector('[data-carousel-track]');
      var slides = carousel.querySelectorAll('[data-carousel-slide]');
      var totalSlides = slides.length;
      if (totalSlides <= 1) return;

      var prevBtn = carousel.querySelector('[data-carousel-prev]');
      var nextBtn = carousel.querySelector('[data-carousel-next]');
      var dots = carousel.querySelectorAll('[data-carousel-dot-index]');

      var current = 0;

      /* ---- update arrows ---- */
      function updateArrows() {
        if (prevBtn) {
          if (current === 0) {
            prevBtn.classList.add('disabled');
            prevBtn.disabled = true;
          } else {
            prevBtn.classList.remove('disabled');
            prevBtn.disabled = false;
          }
        }
        
        if (nextBtn) {
          if (current === totalSlides - 1) {
            nextBtn.classList.add('disabled');
            nextBtn.disabled = true;
          } else {
            nextBtn.classList.remove('disabled');
            nextBtn.disabled = false;
          }
        }
      }

      /* ---- move to slide ---- */
      function goTo(index) {
        if (index < 0 || index >= totalSlides) return;

        current = index;
        track.style.transform = 'translateX(-' + (current * 100) + '%)';

        // Update dots
        dots.forEach(function (dot, i) {
          dot.classList.toggle('card-carousel__dot--active', i === current);
        });

        // Update slides active state
        slides.forEach(function (slide, i) {
          slide.classList.toggle('card-carousel__slide--active', i === current);
        });

        updateArrows();
      }

      /* ---- prev ---- */
      if (prevBtn) {
        prevBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (current > 0) {
            goTo(current - 1);
          }
        }, true);
      }

      /* ---- next ---- */
      if (nextBtn) {
        nextBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (current < totalSlides - 1) {
            goTo(current + 1);
          }
        }, true);
      }

      /* ---- dots ---- */
      dots.forEach(function (dot) {
        dot.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          goTo(parseInt(dot.dataset.carouselDotIndex, 10));
        }, true);
      });

      /* ---- swipe ---- */
      var touchStartX = 0;
      carousel.addEventListener('touchstart', function (e) {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      carousel.addEventListener('touchend', function (e) {
        var diff = touchStartX - e.changedTouches[0].screenX;
        if (Math.abs(diff) > 40) {
          if (diff > 0 && current < totalSlides - 1) {
            goTo(current + 1);
          } else if (diff < 0 && current > 0) {
            goTo(current - 1);
          }
        }
      }, { passive: true });

      /* ---- init ---- */
      goTo(0);
    });
  }

  // Initialize carousels when document is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCarousels);
  } else {
    initCarousels();
  }

  // Make the init function globally accessible
  window.initCardCarousels = initCarousels;
})();

(function () {
  const loaderResetTimeouts = new WeakMap();
  const FALLBACK_RESET_MS = 1800;

  function setProductAtcLoading(button, isLoading) {
    if (!button) return;

    if (isLoading) {
      button.classList.add('loading');
      button.setAttribute('aria-busy', 'true');
      button.setAttribute('aria-disabled', 'true');
      return;
    }

    button.classList.remove('loading');
    button.removeAttribute('aria-busy');
    button.removeAttribute('aria-disabled');
  }

  function clearPendingReset(button) {
    const timeoutId = loaderResetTimeouts.get(button);
    if (timeoutId) {
      clearTimeout(timeoutId);
      loaderResetTimeouts.delete(button);
    }
  }

  function scheduleFallbackReset(button) {
    clearPendingReset(button);
    const timeoutId = setTimeout(() => {
      setProductAtcLoading(button, false);
      loaderResetTimeouts.delete(button);
    }, FALLBACK_RESET_MS);
    loaderResetTimeouts.set(button, timeoutId);
  }

  function findButtonsByVariantId(variantId) {
    if (!variantId) return [];
    const normalizedVariantId = String(variantId);
    return Array.from(
      document.querySelectorAll(`button.custom_product_ATC[data-var-id="${normalizedVariantId}"]`)
    );
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('button.custom_product_ATC');
    if (!button) return;

    if (button.hasAttribute('disabled') || button.getAttribute('aria-disabled') === 'true') return;

    setProductAtcLoading(button, true);
    scheduleFallbackReset(button);
  });

  window.addEventListener('animeal:cart:request-start', (event) => {
    if (event?.detail?.source !== 'product-form') return;

    const matchedButtons = findButtonsByVariantId(event?.detail?.variantId);
    matchedButtons.forEach((button) => {
      clearPendingReset(button);
      setProductAtcLoading(button, true);
    });
  });

  window.addEventListener('animeal:cart:request-end', (event) => {
    if (event?.detail?.source !== 'product-form') return;

    const matchedButtons = findButtonsByVariantId(event?.detail?.variantId);
    if (!matchedButtons.length) {
      document.querySelectorAll('button.custom_product_ATC.loading').forEach((button) => {
        clearPendingReset(button);
        setProductAtcLoading(button, false);
      });
      return;
    }

    matchedButtons.forEach((button) => {
      clearPendingReset(button);
      setProductAtcLoading(button, false);
    });
  });
})();

   



(function () {

  function injectOrderCounts(root = document) {
    const items = root.querySelectorAll('.product-card-additional-inner-main');

    if (!items.length) return;

    items.forEach((el) => {
      if (el.dataset.filled === 'true') return;
      el.dataset.filled = 'true';

      const random = Math.floor(Math.random() * (3000 - 500 + 1)) + 500;
      const formatted =
        random >= 1000 ? `${Math.floor(random / 1000)}K+` : random;

      el.innerHTML = `<span class="order-count">${formatted} bought in past month</span>`;
    });
  }

  // Run once for normal cards
  document.addEventListener('DOMContentLoaded', () => {
    injectOrderCounts();
  });

  // 🔥 OBSERVE RELATED PRODUCTS LOAD
  const target = document.querySelector('product-recommendations');

  if (!target) return;

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length > 0) {
        injectOrderCounts(target);
      }
    });
  });

  observer.observe(target, {
    childList: true,
    subtree: true,
  });

})();









